import { RootState } from 'store';

export const getGlobalToast = (state: RootState) => state.application.globalToast;